import { Button } from "PFComponents/button";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

type CreateNewFrameworkButtonProps = {
  className?: string;
};

export const CreateNewFrameworkButton = ({ className }: CreateNewFrameworkButtonProps) => {
  const { t } = useTranslation("skillsFrameworks");
  const history = useHistory();
  return (
    <Button
      icon="add"
      text={t("list.createNewFramework")}
      className={className}
      onClick={() => history.push("/admin/skills_frameworks/new")}
    />
  );
};
